


























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DaisyMessage from '@/domain/daisy-message/entity/daisy-message.entity';
import DaisyMessageFilter from '@/domain/daisy-message/entity/daisy-message-filter.entity';
import DaisyMessageFormModal from './form/daisy-message-form-modal.component.vue';
import MessageTypes from './daisy-message-types.json';

@Component({
  components: {
    LabelSlot,
    DaisyMessageFormModal,
  },
})
export default class DaisyMessageFilterComponent extends Vue {
  @Prop({
    type: Boolean,
  }) hasCreateDaisyMessage!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  }) existingLanguages!: string[];

  filter: DaisyMessageFilter = new DaisyMessageFilter();

  messageTypes = MessageTypes;

  statusOptions = [
    { text: 'Todos', value: null },
    { text: 'Ativos', value: true },
    { text: 'Inativos', value: false },
  ];

  openModal: boolean = false;

  newMessage: DaisyMessage = new DaisyMessage();

  sendFilter(): void {
    this.$emit('sendFilter', this.filter);
  }

  clearFilter(): void {
    this.filter = new DaisyMessageFilter();
    this.sendFilter();
  }

  openCreateModal(): void {
    this.newMessage = new DaisyMessage();
    this.openModal = true;
  }

  closeModal(): void {
    this.openModal = false;
    this.sendFilter();
  }
}
